import { Card } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register Pie/Donut Chart dependencies
ChartJS.register(ArcElement, Tooltip, Legend);

const STATUS_CONFIG = [
  { label: "Requested", color: "#919191", key: "requestedCount" },
  { label: "Received", color: "#745AF2", key: "receivedCount" },
  { label: "In-Progress", color: "#009EFB", key: "inProgressCount" },
  { label: "Completed", color: "#55CE63", key: "completedCount" },
  { label: "Due > 10 Days", color: "#DE942A", key: "countGreaterThanTenDays" },
  { label: "Due > 14 Days",color: "#FF5747", key: "countGreaterThanFourteenDays"},
];

const styles = {
  sampleStatusCard: {
    minWidth: 200,
    marginBottom: 24,
    boxSizing: "border-box",
    padding: 0,
    height: "100%",
  },
  donutWrap: {
    width: 200,
    maxWidth: "100%",
    margin: "0 auto 18px auto",
    display: "flex",
    justifyContent: "center",
  },
  statusCircleBarArranged: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
  },
  statusRow: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 10, // Reduce/increase for tighter/wider layout
  },
  statusRowTop: {
    marginBottom: 16,
  },
  statusRowBottom: {
    justifyContent: "center",
    width: "65%",
    minWidth: 140,
  },
  statusCircleColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  statusCircle: (color) => ({
    width: 40,
    height: 40,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "1.15rem",
    backgroundColor: color,
    marginBottom: 8,
    boxShadow: "0 2px 8px #0002",
  }),
  statusLabel: {
    fontSize: "0.97rem",
    color: "#222",
    textAlign: "center",
    maxWidth: 80,
    lineHeight: 1.1,
  },
};

const SampleStatus = ({ data = {} }) => {
  const chartData = {
    labels: STATUS_CONFIG.map((s) => s.label),
    datasets: [
      {
        data: STATUS_CONFIG.map((s) =>
          data[s.key] !== undefined ? data[s.key] : 0
        ),
        backgroundColor: STATUS_CONFIG.map((s) => s.color),
        borderWidth: 1,
      },
    ],
  };

  return (
    <Card style={styles.sampleStatusCard}>
      <Card.Body>
        <Card.Title className="mb-3 fs-5 text-start default-font-styles">Sample Status</Card.Title>
        <div style={styles.donutWrap}>
          <Doughnut
            data={chartData}
            options={{
              cutout: "70%",
              plugins: {
                legend: { display: false, position: "bottom" },
              },
            }}
          />
        </div>
        <div style={styles.statusCircleBarArranged}>
          <div style={{ ...styles.statusRow }}>
            {STATUS_CONFIG.map((s) => (
              <div style={styles.statusCircleColumn} key={s.key}>
                <span style={styles.statusCircle(s.color)}>
                  {data[s.key] !== undefined ? data[s.key] : 0}
                </span>
                <span style={styles.statusLabel}>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default SampleStatus;
